import { render, staticRenderFns } from "./r-smart-offer-bundle-decoration-type.vue?vue&type=template&id=1bd3763c"
import script from "./r-smart-offer-bundle-decoration-type.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-bundle-decoration-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bd3763c')) {
      api.createRecord('1bd3763c', component.options)
    } else {
      api.reload('1bd3763c', component.options)
    }
    module.hot.accept("./r-smart-offer-bundle-decoration-type.vue?vue&type=template&id=1bd3763c", function () {
      api.rerender('1bd3763c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-decoration/r-smart-offer-bundle-decoration-type.vue"
export default component.exports